// In this module we would place high order components which will contain others
// Routing, Initializers, Components which wait for an event to render something
import { Provider } from 'react-redux';
import { Router, Switch } from 'react-router-dom';
import { locale } from 'bv-i18n';
import { history } from 'bv-services/route';

import { EmbeddedRoutesView, Layout, Services } from './features';
import { Route } from './features/routing/components/shared';

// Probably here we should call createStore
const { store } = window.reduxState;

const IndexSwitch = () => (
  <Switch>
    <Route path="/components">
      <EmbeddedRoutesView />
    </Route>
    <>
      <Layout />
      <Services />
    </>
  </Switch>
);

const IndexView = () => (
  <Provider store={store}>
    <Router history={history} basename={`/${locale()}`}>
      <IndexSwitch />
    </Router>
  </Provider>
);

IndexView.displayName = 'IndexApp';

export default IndexView;
